import { useMemo } from "react";

import { buildFavoritedPagesMenuItems } from "@utils/favoritedPages";
import NavbarMenuSlot from "@components/navbar/slot_types/NavbarMenuSlot";

export default function FavoritesNavbarMenu() {
  const items = useMemo(() => {
    return buildFavoritedPagesMenuItems({ favoritedPages: window.FAVORITED_PAGES || [] });
  }, []);

  if (items.length === 0) return null;

  return (
    <NavbarMenuSlot
      label={{
        icon: {
          name: "star",
        },
      }}
      items={items}
    />
  );
}
